import { Divider } from "antd";

const FormDivider = ({ title }) => {
    return (
        <Divider
            className="divider register-form-divider"
            orientation="left"

        >
            {title}
        </Divider>

    );
}

export default FormDivider;